export const MODERATION_REASONS = {
  AJPP_AJPA: {
    id: "AJPP_AJPA",
    label: "AJPP / AJPA",
  },

  DECES_DANS_LA_CELLULE_FAMILIALE: {
    id: "DECES_DANS_LA_CELLULE_FAMILIALE",
    label: "Décès dans la cellule familiale",
  },
  DIFFICULTES_LIEES_A_LA_SANTE: {
    id: "DIFFICULTES_LIEES_A_LA_SANTE",
    label: "Difficultés liées à la santé",
  },
  ETUDIANT: {
    id: "ETUDIANT",
    label: "Étudiant",
  },
  FAMILLE_AVEC_ENFANTS_EN_BAS_AGE: {
    id: "FAMILLE_AVEC_ENFANTS_EN_BAS_AGE",
    label: "Famille avec enfants en bas âge",
  },
  HOSPITALISATION: {
    id: "HOSPITALISATION",
    label: "Hospitalisation",
  },
  INCARCERATION: {
    id: "INCARCERATION",
    label: "Incarcération",
  },
  PLUS_DE_60_ANS: {
    id: "PLUS_DE_60_ANS",
    label: "Plus de 60 ans",
  },
  PLUS_DE_62_ANS: {
    id: "PLUS_DE_62_ANS",
    label: "Plus de 62 ans",
  },
  PRESENCE_PERSONNE_EN_SITUATION_DE_HANDICAP: {
    id: "PRESENCE_PERSONNE_EN_SITUATION_DE_HANDICAP",
    label: "Présence d'une tierce personne en situation de handicap au foyer",
  },
  RSA_MAJORE_FREINS_IDENTIFIES: {
    id: "RSA_MAJORE_FREINS_IDENTIFIES",
    label: "RSA majoré (freins identifiés)",
  },
  SDF: {
    id: "SDF",
    label: "SDF",
  },
  SITUATION_DE_HANDICAP_BRSA: {
    id: "SITUATION_DE_HANDICAP_BRSA",
    label: "Situation de handicap du BRSA",
  },
  SITUATION_DE_HANDICAP_ENFANT_OU_CONJOINT: {
    id: "SITUATION_DE_HANDICAP_ENFANT_OU_CONJOINT",
    label: "Situation de handicap enfant ou conjoint",
  },
  SORTIE_DE_PRISON: {
    id: "SORTIE_DE_PRISON",
    label: "Sortie de prison",
  },
  USURPATION_IDENTITE_BRSA: {
    id: "USURPATION_IDENTITE_BRSA",
    label: "Usurpation d'identité du BRSA",
  },
  AUTRE_MOTIF: {
    id: "AUTRE_MOTIF",
    label: "Autre motif (situation particulière identifiée par le RU)",
  },
};
